module.exports = __webpack_public_path__ + "static/media/pycharm.5c99b857.png";